"use client";

import clsx from "clsx";

import { useTranslation } from "~/app/hooks/useTranslation";
import Icon1 from "~/assets/images/instagram/feature-icon-1.svg?react";
import Icon2 from "~/assets/images/instagram/feature-icon-2.svg?react";
import Icon3 from "~/assets/images/instagram/feature-icon-3.svg?react";

import styles from "./SectionFeatureIcons.module.scss";

function FeatureItem({ Icon, title, description }) {
  return (
    <div className={styles.featureItem}>
      <Icon />
      <h4 className={styles.featureTitle}>{title}</h4>
      <p className={styles.featureDescription}>{description}</p>
    </div>
  );
}

export default function SectionFeatureIcons() {
  const { t } = useTranslation();

  return (
    <div className={clsx(styles.icons, "card")}>
      <FeatureItem
        Icon={Icon1}
        title={t("instagram.sectionFeatureIcons.feature1.title")}
        description={t("instagram.sectionFeatureIcons.feature1.desc")}
      />
      <FeatureItem
        Icon={Icon2}
        title={t("instagram.sectionFeatureIcons.feature2.title")}
        description={t("instagram.sectionFeatureIcons.feature2.desc")}
      />
      <FeatureItem
        Icon={Icon3}
        title={t("instagram.sectionFeatureIcons.feature3.title")}
        description={t("instagram.sectionFeatureIcons.feature3.desc")}
      />
    </div>
  );
}
